import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useState, useRef , useEffect} from 'react';
import {isMobileOnly} from 'react-device-detect';
import { remove, uniq, filter, forEach, findIndex } from 'lodash';

const MyEsCateItemBlock = styled.li`
    max-width: ${props => props.maxWidth};
    //margin: 0 2vw 20px 0;
    margin-Right: ${props => props.marginRight};
    margin-bottom: 20px;
    position: relative;
    background-color: #f6f8fa;
    border-radius: 12px;
    cursor: pointer;

    ${isMobileOnly?`
        padding: 3vw;
    `:`
        padding: 15px 20px;
        height: 62px;
    `};
    //margin: 0 10px 20px 0;
    .title {
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 2.38;
        color : #333333;
        //margin-top: 4px;
        ::before1 {
            content: '';
            display: inline-block;
            width: ${props => props.w};
            height: ${props => props.h};
            margin-right: 5px;
            background: url(${props => props.img2}) center center/auto no-repeat;
            //background-image: url(${props => props.img2});
            vertical-align: -10px;
        }
    }

    .icon {
        width: 12vw;
        max-width: ${props => props.w};
        max-height: ${props => props.h};
        float: left;
        margin-right: 5px;
    }

    .num {
        font-weight: 500;
        color: #fc7a35;
    }

    &.dim{
        opacity: 0.6;
    }

    border: ${props => props.border || 'none'};
    opacity: ${props => props.opacity || '1'};
    

    ::after{
        content: "";
        border-top: 1px solid #666666;
        border-right: 1px solid #666666;
        height: 10px;
        width: 10px;
        position: absolute;
        -webkit-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        transform: rotate(-225deg);
        top: calc(100% - 4.6px);
        left: calc(50% - 5px);
        z-index: 5;
        background-color: #f6f8fa;
       display: ${props => props.display || 'none'};
       } 

`;

const MyEsCateHeaderBlock = styled.div`
       float: left;
       position: relative;
`;

const MyEsCategoryBlock = styled.div`
    display: ${props => props.display || 'none'};
    width: 100vw;
    position: relative;
    ${isMobileOnly&&`
        .tf-list {
            display:flex;
            flex-wrap:wrap;
            align-items: flex-start;
        }      
    `};
`;

const MyEsCateItem = ({data, maxWidth, handleFistCateClick, active=false, selId, marginRight}) => {
    
    //const [active, setActive] = useState(false);
    const refBlock = useRef(null);
    const [count, setCount] = useState(0);
    const itemMargin = isMobileOnly?{marginLeft: '0px', marginTop: '0px'}:{marginLeft: '40px', marginTop: '18px'};

    const { esMyBrandCate1Step } = useSelector(
        ({ esMyReducer }) => ({
            esMyBrandCate1Step: esMyReducer.esMyBrandCate1Step,

        })
    );

    useEffect(() => {
        if(esMyBrandCate1Step && data && data.category && data.category.cate2) {
            let num = 0;

            for(let i = 0; i < data.category.cate2.length ; i++) {
                let objIdx = findIndex(esMyBrandCate1Step, (obj) => {
                    const cateid = (data.category.id * 100) + data.category.cate2[i].id;
                    return (obj === cateid);
                })

                if(objIdx >= 0) {
                    num++;
                    
                }
            }
            setCount(num);
        }
        
    }, [esMyBrandCate1Step]);

    // console.log("brandname : " + brandname);

    const onClick = () => {
        handleFistCateClick(data.id);
        /* if(refBlock && refBlock.current) {
            //refBlock.current.addClass('test')
            if(!active) {
                console.log("active")
                //refBlock.current.classList.add('active');
                refBlock.current.classList.remove('dim');
                
                setActive(true);
            } else {
                console.log("deactive")
                refBlock.current.classList.add('dim');
                //refBlock.current.classList.remove('active');
                setActive(false);
            }
            
        } */
    }
    
    const handleCateClick = (cateid) => {

    }

    const handleAllCheckClick = (isForce) => {

    }

    const checkActive = (cateid) => {

    }


    return (
        <MyEsCateItemBlock maxWidth={maxWidth} marginRight={marginRight} img2={active? data.imgAct:data.img} w={data.w} h={data.h} 
        border={active? "solid 1px #666666":"none"} opacity={active||selId<0? "1":"0.6"} 
        display={active? "block":"none"} ref={refBlock} onClick={onClick}>
            <img src={active? data.imgAct:data.img} className="icon"/>
            <MyEsCateHeaderBlock >
                <div className="title" ><span>{data.name}<span className="num">{count>0? '('+count + ')':""}</span></span></div>
            </MyEsCateHeaderBlock>
        </MyEsCateItemBlock>
    );
};

export default MyEsCateItem;